export enum CustomerSource {
  DataWarehouse = 'DWH',
  MadeToMeasure = 'MTM_APP',
  // Synced from the CDP (customers:sync-cdp, since 30 Sep 2026). Read-only like DWH:
  // every check in the app tests for MadeToMeasure, so CDP behaves as DWH does.
  Cdp = 'CDP',
}
